import React, { useState } from "react";
import type { SortedSpecType } from "../../../../../../common-deprecated/types/SpecTypes";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import Popover from "../../../../../../common-deprecated/components/popover/aem/lexus/Popover";
import type { BuildAndBuyDispatchType } from "../../../redux/store";
import { useBnbSelector } from "../../../redux/store";
import * as Flex from "../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as Button from "../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import * as Type from "../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import * as Styles from "./styles/SpecList";
import * as IconWrapper from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import * as SummaryStyles from "./styles/Summary";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import { BnbLabel, useBnbLabel, useBnbOptionalLabel } from "../../../utils/labels";
import { MODAL_CONTENT } from "../../../../../../common-deprecated/utils/modalConstants";
import SpecificationValue from "../common/SpecificationValue";
import { getEvDisclaimer } from "../../../utils/settings/bnbSettingUtils";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

type SpecListPropsType = {
    specs: SortedSpecType[];
    title?: React.ReactNode;
    singleColumn?: boolean;
    noDropdown?: boolean;
    trackOpen?: () => void;
    defaultOpen?: boolean;
    children?: React.ReactNode;
};

const SpecList = (props: SpecListPropsType): JSX.Element => {
    const { specs, title, trackOpen, defaultOpen, children, singleColumn, noDropdown } = props;
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const settings = useBnbSelector((state) => state.commonSettings);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);

    const [isOpen, setIsOpen] = useState(!!defaultOpen);
    const showAccessoryDisclaimer = !!useBnbOptionalLabel("accessoryDisclaimer");

    const moreInfoLabel = useBnbLabel("moreInfo");

    const toggleState = (): void => {
        if (!isOpen && trackOpen) {
            trackOpen();
        }
        setIsOpen(!isOpen);
    };

    const openMoreInfoModal = (data: string): void => {
        const footer = showAccessoryDisclaimer ? <BnbLabel label="accessoryDisclaimer" useHTML /> : undefined;
        dispatch(
            showModal({
                type: MODAL_CONTENT,
                content: data,
                useHTML: true,
                title: moreInfoLabel,
                footer,
            }),
        );
    };

    return (
        <Styles.Wrapper isOpen={isOpen}>
            {!noDropdown && (
                <Styles.Header onClick={toggleState}>
                    <Styles.DropDownTitle>{title}</Styles.DropDownTitle>
                    <IconWrapper.ToggleIconWrapper isDown={isOpen}>
                        <Icon variant="chevronDown" />
                    </IconWrapper.ToggleIconWrapper>
                </Styles.Header>
            )}
            {(isOpen || noDropdown) &&
                specs.map((spec) => (
                    <Styles.DropDown key={spec.id}>
                        {spec.title && (
                            <Type.H6 mx={0} mb={1}>
                                {!!spec.title && spec.title}
                                {/* Disclaimer is only used for WLTP tooltips which currently is only used in summary */}
                                {!!spec.disclaimer && <Popover showOnClick content={spec.disclaimer} />}
                            </Type.H6>
                        )}
                        {children}
                        {!!spec.data &&
                            spec.data.map((data) => (
                                <SummaryStyles.Row key={data.id}>
                                    <Flex.Row justifyContent="space-between">
                                        <Flex.Col width={singleColumn ? "100%" : undefined}>
                                            {data.name}
                                            {data.description && (
                                                <Button.Link onClick={() => openMoreInfoModal(data.description!)}>
                                                    <IconWrapper.IconWrapper>
                                                        <Icon variant="info" />
                                                    </IconWrapper.IconWrapper>
                                                </Button.Link>
                                            )}
                                            {getEvDisclaimer(bnbSettings, settings, data.internalCode) && (
                                                <>
                                                    {" "}
                                                    <Popover
                                                        showOnClick
                                                        content={
                                                            getEvDisclaimer(bnbSettings, settings, data.internalCode)!
                                                        }
                                                        useHTML
                                                    />
                                                </>
                                            )}
                                        </Flex.Col>
                                        {!singleColumn && (
                                            <Flex.Col>
                                                {settings.culture ? (
                                                    <SpecificationValue currentSpec={data} allSpecs={spec.data!} />
                                                ) : (
                                                    `${data.value} ${data.unit}`.trim()
                                                )}
                                                {data.tooltip && (
                                                    <>
                                                        {" "}
                                                        <Popover showOnClick content={data.tooltip} useHTML />
                                                    </>
                                                )}
                                            </Flex.Col>
                                        )}
                                    </Flex.Row>
                                </SummaryStyles.Row>
                            ))}
                    </Styles.DropDown>
                ))}
        </Styles.Wrapper>
    );
};

export default SpecList;
